export const GET_FILTER = "GET_FILTER"
export const GET_OFFER_TYPE = "GET_OFFER_TYPE"
